import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import {
  createNewCountry,
  fetchCountryList,
  fetchEditCountry,
} from "../actions/country";
import { useNavigate, useParams } from "react-router-dom";

import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

const CountryAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  //breadcrumb
  const translateForm = "countryForm";
  const translateModule = "country";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { countryDetail } = useSelector((state) => state.countryReducer);

  const initialState = {
    name: "",
    currency: "RSD",
    code: "",
    status: "ACTIVE",
    licenceName: "",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchCountryList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (countryDetail && id) {
      setData({
        ...data,
        name: countryDetail.name || "",
        currency: countryDetail.currency || "",
        code: countryDetail.code || "",
        status: countryDetail.status || "",
        licenceName: countryDetail.licenceName || "",
        createdAt: countryDetail.createdAt || "",
        updatedAt: countryDetail.updatedAt || "",
      });
    }
  }, [countryDetail, id]);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const clientValidationHandler = () => {
    const { name, licenceName, code } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
      licenceName,
      code,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }
    if (id) {
      data.id = id;
      dispatch(fetchEditCountry(data, navigate));
    } else {
      dispatch(createNewCountry(data, navigate));
    }
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        extraTitle={countryDetail && countryDetail.name}
        pageType={pageType}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Card>
                    <Card.Header>
                      <FormTitleMain />
                    </Card.Header>
                    <Card.Body>
                      <div className="product-holder-admin-left-side-text">
                        <Row>
                          <Col lg={5} md={12} xs={12} className="mb-3">
                            <InputField
                              label={t(`${translateForm}.name`)}
                              name="name"
                              value={data.name}
                              error={errors}
                              errorsHandler={setErrors}
                              onChange={handleInputChange}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          <Col lg={4} md={12} xs={12} className="mb-3">
                            <InputField
                              label={t(`${translateForm}.licenceName`)}
                              name="licenceName"
                              value={data.licenceName}
                              error={errors}
                              errorsHandler={setErrors}
                              onChange={handleInputChange}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          <Col lg={3} md={12} xs={12} className="mb-3">
                            <InputField
                              label={t(`${translateForm}.code`)}
                              name="code"
                              value={data.code}
                              error={errors}
                              errorsHandler={setErrors}
                              onChange={handleInputChange}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          {/* <Col lg={3} md={12} xs={12} className="mb-3">
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">
                                {t(`${translateForm}.vat`)}
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.currency}
                                label={t(`${translateForm}.vat`)}
                                name="currency"
                                onChange={handleInputChange}
                                size="small"
                              >
                                <MenuItem value="RSD">RSD</MenuItem>
                                <MenuItem value="EUR">EUR</MenuItem>
                              </Select>
                            </FormControl>
                          </Col> */}
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CountryAdd;
